import React, { useState } from 'react';
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { Default } from './Layouts/Default';

const layouts = {
  multicolumns: Default
};

export const Footer = ({ sublevel, globals, settings, links, shop, type }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const Layout = layouts[settings.layout] || Default;

  // Process links to apply the text styling settings
  const processedLinks = links.map(link => {
    if (link.type === 'list' && link.settings) {
      // Apply header_type to list headers
      return {
        ...link,
        settings: {
          ...link.settings,
          header_type: link.settings.header_type || 'h3',
          links_type: link.settings.links_type || 'footer-link'
        }
      };
    } else if (link.type === 'email_subscribe' && link.settings) {
      // Apply all the text types for email subscribe section
      return {
        ...link,
        settings: {
          ...link.settings,
          header_type: link.settings.header_type || 'h2',
          top_text_type: link.settings.top_text_type || 'b3',
          content_type: link.settings.content_type || 'b2',
          sign_up_message_type: link.settings.sign_up_message_type || 'disclaimer',
          contact_info_type: link.settings.contact_info_type || 'contact-text'
        }
      };
    }
    
    return link;
  });

  return (
    <Layout 
      sublevel={sublevel}
      globals={globals}
      settings={settings}
      links={processedLinks}
      shop={shop}
      isMobile={isMobile}
    />
  );
};

export default Footer;
